import { AfterContentInit, AfterViewInit, Component, DoCheck } from '@angular/core';
import { Router } from '@angular/router';
import { PHRMStoreModel } from '../../pharmacy/shared/phrm-store.model';
import { MessageboxService } from '../../shared/messagebox/messagebox.service';
import { RouteFromService } from '../routefrom.service';
import { ActivateInventoryService } from './activate-inventory.service';
import { CacheService } from '../utilities/cache.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: false,
  selector: 'app-activate-dispensary',
  templateUrl: './activate-inventory.component.html',
  //styleUrls: ['./activate-inventory.component.css']
})
export class ActivateInventoryComponent {
  inventoryList: PHRMStoreModel[] = [];

  constructor(
    private activateInvService: ActivateInventoryService,
    private msgBox: MessageboxService,
    private _router: Router,
    private routeFrom: RouteFromService,
    private cache: CacheService,
    private translate: TranslateService
  ) {
    this.GetAllInventory();
  }

  GetAllInventory() {
    this.activateInvService.GetAllInventories()
      .subscribe((res: any) => {
        if (res.Succeeded) {
          this.inventoryList = res.Data;
          //this.inventoryList = this.inventoryList.filter(a => a.IsActive == true);
          // if only one inventory is available for the user, automatically set it as active inventory
          if (this.inventoryList.length == 1) {
            ////this.msgBox.showMessage("Warning", [`You are only allowed to see ${this.inventoryList[0].Name}.`]);
            this.setGlobalDispensary(this.inventoryList[0].StoreId);
          }
        }
        else {
          this.msgBox.showMessage("Failed", [this.translate.instant("activateInventory.selector.loadFailed")]);
        }
      }, () => {
        this.msgBox.showMessage("Failed", [this.translate.instant("activateInventory.selector.loadFailed")]);
      });
  }

  async setGlobalDispensary(storeId: number) {
    var selectedInventory: any = this.inventoryList.find(a => a.StoreId == storeId);
    this.activateInvService.activeInventory = selectedInventory;
    await this.cache.set<PHRMStoreModel>('activeInventory', selectedInventory);
    this._router.navigate([`/${this.routeFrom.RouteFrom}`]);
  }
}
